import { Share2, Gift, Handshake, Building2, Mic, Landmark, Globe } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

export interface ContainerDefinition {
  id: string;
  name: string;
  route: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const CONTAINER_REGISTRY: readonly ContainerDefinition[] = [
  { id: 'socials-container', name: 'Socials', route: '/socials', icon: Share2 },
  { id: 'web-and-tech-container', name: 'Web and Tech', route: '/web-and-tech', icon: Globe },
  { id: 'graphics-and-swag-container', name: 'Graphics & Swag', route: '/graphics-and-swag', icon: Gift },
  { id: 'sponsors-container', name: 'Sponsors', route: '/sponsors', icon: Handshake },
  { id: 'operations-container', name: 'Operations', route: '/operations', icon: Building2 },
  { id: 'speakers-container', name: 'Speakers', route: '/speakers', icon: Mic },
  { id: 'board-container', name: 'Board', route: '/board', icon: Landmark },
];

export const CONTAINER_IDS = new Set(CONTAINER_REGISTRY.map((c) => c.id));

export function isContainerId(id: string): boolean {
  return CONTAINER_IDS.has(id);
}

export function containerById(id: string): ContainerDefinition | undefined {
  return CONTAINER_REGISTRY.find((c) => c.id === id);
}
